module.exports = __webpack_public_path__ + "images/9-i98beee9747b4e40e17df0d9bd823f31c.svg";